/* ==========================================================================
   FORMERA — assets/formera-app.js
   Vanilla interaction layer for the static 1:1 replica.

   The pages ship the ORIGINAL hydrated markup + ORIGINAL compiled CSS, so every
   widget (cart aside, menu aside, search overlay, size panel, wishlist drawer,
   AND the site's particle <canvas>) already exists in the DOM in its closed /
   inert state. This file only drives those existing elements — it never invents
   markup, copy or styling. Class pairs taken from the captured live states:
       aside : translate-x-full            <-> translate-x-0
       scrim : opacity-0 pointer-events-none <-> opacity-100
       panel : translate-y-full opacity-0 pointer-events-none <-> translate-y-0 opacity-100
   ========================================================================== */
(function () {
  'use strict';

  var LS_CART = 'formera_cart', LS_WISH = 'formera_wishlist';
  /* Resolve any bare filename against the ACTUAL <script> tag Shopify served us from, so
     every dynamically-built <img src> keeps working no matter what CDN path assets/ lives at. */
  var ASSETS_BASE = (function () {
    var cur = document.currentScript || document.querySelector('script[src*="formera-app.js"]');
    var src = (cur && cur.src) || '';
    var i = src.lastIndexOf('/');
    return i > -1 ? src.slice(0, i + 1) : '';
  })();
  function assetUrl(name) { return name ? ASSETS_BASE + name : name; }
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var norm = function (s) { return (s || '').replace(/\s+/g, ' ').trim(); };
  var label = function (el) { return norm(el.getAttribute && el.getAttribute('aria-label')); };
  var text  = function (el) { return norm(el.textContent); };
  var read  = function (k, d) { try { return JSON.parse(localStorage.getItem(k)) || d; } catch (e) { return d; } };
  var write = function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} };
  var money = function (n) { return '$' + Number(n || 0).toFixed(2); };
  var priceIn = function (s) { var m = norm(s).match(/\$\s*([\d,]+(?:\.\d{2})?)/); return m ? parseFloat(m[1].replace(/,/g, '')) : null; };

  /* ---------------- open/close helpers (original class pairs) ---------------- */
  function slideOpen(el) { if (el) { el.classList.remove('translate-x-full'); el.classList.add('translate-x-0'); } }
  function slideShut(el) { if (el) { el.classList.add('translate-x-full'); el.classList.remove('translate-x-0'); } }
  function fadeOn(el)    { if (el) { el.classList.remove('opacity-0', 'pointer-events-none'); el.classList.add('opacity-100'); el.style.pointerEvents = 'auto'; } }
  function fadeOff(el)   { if (el) { el.classList.add('opacity-0', 'pointer-events-none'); el.classList.remove('opacity-100'); el.style.pointerEvents = ''; } }
  function panelOn(el)   { if (el) { el.classList.remove('translate-y-full', 'opacity-0', 'pointer-events-none'); el.classList.add('translate-y-0', 'opacity-100', 'pointer-events-auto'); } }
  function panelOff(el)  { if (el) { el.classList.add('translate-y-full', 'opacity-0', 'pointer-events-none'); el.classList.remove('translate-y-0', 'opacity-100', 'pointer-events-auto'); } }
  function lock(on)      { document.documentElement.style.overflow = on ? 'hidden' : ''; }

  function asideBy(lbl) {
    return $$('aside').filter(function (a) { return (label(a) || '').toLowerCase() === lbl.toLowerCase(); })[0] || null;
  }
  /* full-viewport dim layer nearest a panel (their scrims are `fixed inset-0 ... bg-black/NN`) */
  function scrims() {
    return $$('div').filter(function (d) {
      var c = (d.className || '') + '';
      return /fixed/.test(c) && /inset-0/.test(c) && /bg-black/.test(c);
    });
  }
  function anyScrimOn()  { scrims().forEach(fadeOn); }
  function anyScrimOff() { scrims().forEach(fadeOff); }

  /* ========================= CART ========================= */
  var Cart = {
    aside: null, body: null, emptyTpl: '',
    init: function () {
      this.aside = asideBy('Shopping Cart');
      if (!this.aside) return;
      this.body = $('.flex-1.overflow-y-auto', this.aside) || this.aside.children[1] || null;
      if (this.body) this.emptyTpl = this.body.innerHTML;   // ORIGINAL empty-state markup, kept verbatim
      this.render(); this.badge();
    },
    open:  function () { slideOpen(this.aside); anyScrimOn();  lock(true); },
    close: function () { slideShut(this.aside); anyScrimOff(); lock(false); },
    items: function () { return read(LS_CART, []); },
    add: function (it) {
      if (!it || !it.name) return;
      var items = this.items();
      var hit = items.filter(function (i) { return i.sku === it.sku; })[0];
      if (hit) hit.qty += (it.qty || 1);
      else items.push({ sku: it.sku, name: it.name, variant: it.variant || '', price: it.price || 0,
                        img: it.img || '', qty: it.qty || 1, variant_id: it.variant_id || null });
      write(LS_CART, items); this.render(); this.badge(); this.open();
      /* 📊 META AddToCart — browser pixel + CAPI, ONE shared event_id (see snippets/meta-pixel.liquid).
         Fired HERE, at the one choke point all four add-to-cart call sites route through (card chip,
         card button, PDP, slide-cart upsell), so ATC can never be wired to three of them and missed on
         the fourth — the exact failure Take LUM shipped for weeks (their mom funnel reported ZERO ATC
         because one template's goToCheckout() never called lumTrackATC).
         🔒 Only the numeric variant id and the value leave the browser — never the product name.
         Analytics only: nothing below can mutate the cart or the price. */
      try{
        if (window.fmTrackATC) {
          var _q = it.qty || 1;
          window.fmTrackATC([{ id: String(it.variant_id || it.sku || ''), quantity: _q }],
                            (Number(it.price) || 0) * _q);
        }
      }catch(e){}
      /* 📧 KLAVIYO "Added to Cart" — the trigger behind the abandon-checkout flows.
         Fired at the SAME choke point as the Meta event above and for the same reason: all four
         add-to-cart call sites route through here, so it can never be wired to three and missed on
         the fourth. Listener + payload live in snippets/formera-klaviyo.liquid; the detail is the
         line as it now stands in the cart. Analytics only — nothing here can mutate cart or price. */
      try {
        document.dispatchEvent(new CustomEvent('formera:cart-add', {
          detail: hit || items[items.length - 1]
        }));
      } catch (e) {}
    },
    setQty: function (sku, q) {
      var items = this.items().map(function (i) { if (i.sku === sku) i.qty = Math.max(0, q); return i; })
                              .filter(function (i) { return i.qty > 0; });
      write(LS_CART, items); this.render(); this.badge();
    },
    badge: function () {
      var n = this.items().reduce(function (a, i) { return a + i.qty; }, 0);
      $$('[data-formera-cart-count]').forEach(function (e) { e.textContent = n; });
    },
    /* Filled-cart markup replicated from the captured original
       (refs/ascend-1to1/states/cart-with-items.html): free-shipping progress bar, line items with
       size chip + rounded qty stepper, promo row, Subtotal/Shipping/Total, Proceed to Checkout,
       card marks. Their Stripe express-wallet element is intentionally NOT reproduced (their account). */
    render: function () {
      if (!this.body) return;
      var items = this.items(), self = this;
      if (!items.length) {
        this.body.innerHTML = this.emptyTpl;
        var pb0 = document.getElementById('formera-ship-bar'); if (pb0) pb0.remove();
        var ft0 = document.getElementById('formera-cart-foot'); if (ft0) ft0.remove();
        return;
      }
      var sub = items.reduce(function (a, i) { return a + i.price * i.qty; }, 0);
      /* FREE SHIPPING ON ALL USA ORDERS (Dom 2026-08-04). Threshold retired: `remain` is always 0
         and `ship` always 0. ⚠️ FREE must not be used as a divisor again — `sub / 0 * 100` is
         Infinity, which is why the progress track below was removed rather than left at 100%. */
      var FREE = 0, SHIP = 0;
      var remain = 0;
      var ship = 0;
      var disc = cartDiscount(items);          /* null if priced against a DIFFERENT cart */
      var self2 = this;
      /* cart changed since the code was priced -> re-price against the server, then repaint.
         Until it comes back `disc` is null, so a stale number is never on screen. */
      revalidateDiscount(items, function(){ try{ self2.render(); }catch(e){} });
      /* how many units of each line the discount makes free (server-allocated, not re-derived) */
      var freeBy = {};
      if (disc && disc.freeUnits) disc.freeUnits.forEach(function(u){
        var k=(u.sku||'')+'|'+(u.variant||''); freeBy[k]=(freeBy[k]||0)+1; });

      var minus = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5" aria-hidden="true"><path d="M5 12h14"></path></svg>';
      var plus  = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-3.5 h-3.5" aria-hidden="true"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';
      var trash = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>';
      var truck = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-4 w-4 shrink-0 text-[#4a8dff]" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"></path><path d="M15 18H9"></path><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"></path><circle cx="17" cy="18" r="2"></circle><circle cx="7" cy="18" r="2"></circle></svg>';
      var arrow = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" aria-hidden="true"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg>';

      /* free-shipping progress bar sits between header and scroll body */
      var head = this.aside.children[0];
      var bar = document.getElementById('formera-ship-bar');
      if (!bar) {
        bar = document.createElement('div');
        bar.id = 'formera-ship-bar';
        bar.className = 'border-b border-slate-100 px-4 py-2.5 sm:px-6 sm:py-3';
        head.parentNode.insertBefore(bar, head.nextSibling);
      }
      /* FREE SHIPPING ON ALL USA ORDERS (Dom 2026-08-04) — one unconditional statement. The
         two-branch progress bar is gone: there is no threshold left to make progress toward, and
         a track pinned at 100% forever reads as a broken widget rather than a benefit. */
      bar.innerHTML = '<p class="flex items-center gap-1.5 text-xs text-slate-700 sm:text-sm">' + truck +
        '<span class="font-semibold text-[#4a8dff]">FREE USPS Express 1-2 Day Shipping on all USA orders</span></p>';

      this.body.innerHTML = '<ul class="space-y-2">' + items.map(function (i) {
        return '<li data-sku="' + i.sku.replace(/"/g, '&quot;') + '" class="flex gap-2.5 items-center p-2 rounded-xl border border-slate-100 bg-white hover:border-slate-200 transition-colors">' +
          '<div class="w-20 h-20 rounded-md bg-slate-50 border border-slate-100 flex items-center justify-center shrink-0 overflow-hidden">' +
            (i.img ? '<img alt="' + i.name + '" class="h-[125%] w-[125%] max-w-none object-contain drop-shadow-sm" loading="lazy" decoding="async" src="' + i.img + '">' : '') +
          '</div>' +
          '<div class="flex-1 min-w-0">' +
            '<div class="flex items-start justify-between gap-2">' +
              '<div class="min-w-0 flex flex-col items-start">' +
                '<h3 class="max-w-full font-bold text-sm text-slate-900 leading-snug truncate">' + i.name + '</h3>' +
                (i.variant ? '<span class="mt-0.5 rounded bg-[#d3def6] px-1.5 py-0.5 text-[10px] font-semibold text-[#3559a6]">' + String(i.variant).replace(/^(\d+(?:\.\d+)?)\s*(mg|ml|iu)$/i, '$1 $2') + '</span>' : '') +
              '</div>' +
              '<button data-cart-rm class="text-slate-400 hover:text-red-600 transition-colors shrink-0" aria-label="Remove ' + i.name + (i.variant ? ' - ' + i.variant : '') + '">' + trash + '</button>' +
            '</div>' +
            '<div class="mt-1.5 flex items-center justify-between gap-2">' +
              '<div class="inline-flex items-center border border-slate-200 rounded-full">' +
                '<button data-cart-dec class="w-6 h-6 flex items-center justify-center text-slate-600 hover:text-slate-900" aria-label="Decrease quantity">' + minus + '</button>' +
                '<span class="w-6 text-center text-sm font-medium">' + i.qty + '</span>' +
                '<button data-cart-inc class="w-6 h-6 flex items-center justify-center text-slate-600 hover:text-slate-900" aria-label="Increase quantity">' + plus + '</button>' +
              '</div>' +
              '<div class="flex items-center gap-2">' + (function(){
              /* 🔑 Dom 2026-08-05: the customer must SEE which unit is free, not just a lump discount. */
              var f = freeBy[(i.sku||'')+'|'+(i.variant||'')] || 0;
              if (f >= i.qty) return '<span class="text-xs font-semibold text-slate-400 line-through">' + money(i.price*i.qty) + '</span>' +
                                     '<span class="text-sm font-extrabold text-[#1f7a4d]">FREE</span>';
              if (f > 0)     return '<span class="text-[10px] font-semibold text-[#1f7a4d]">' + f + ' free</span>' +
                                     '<span class="text-sm font-bold text-slate-900">' + money(i.price*(i.qty-f)) + '</span>';
              return '<span class="text-sm font-bold text-slate-900">' + money(i.price*i.qty) + '</span>';
            })() + '</div>' +
            '</div>' +
          '</div></li>';
      }).join('') + '</ul>';

      /* footer: promo + totals + checkout + card marks */
      var foot = document.getElementById('formera-cart-foot');
      if (!foot) {
        foot = document.createElement('div');
        foot.id = 'formera-cart-foot';
        foot.className = 'border-t border-slate-200 px-4 py-2.5 space-y-1.5 sm:px-6 sm:py-4 sm:space-y-3 bg-white shrink-0';
        this.aside.appendChild(foot);
      }
      var CARDS = ['visa_card', 'mastercard_card', 'discover_card', 'amex_card'].map(function (n) {
        return '<img alt="" class="h-6 w-10 shrink-0 object-contain" loading="lazy" decoding="async" src="' + assetUrl(n + '.png') + '">';
      }).join('');
      /* Dom QA 2026-07-30: driven by snippets/upsell-data.liquid (the real Shopify product), never
         hard-coded — the old literal had the wrong name, wrong price, HCG's image and NO variant_id,
         so anything added here could not be resolved to a real variant at checkout. */
      var REC = window.FORMERA_UPSELL || null;
      var recHtml = (!REC || items.some(function (i) { return i.sku === REC.sku; })) ? '' :
        '<div class="rounded-xl border border-slate-200 bg-slate-50 p-2.5 sm:rounded-2xl sm:p-4"><div class="flex gap-2 sm:gap-3 items-center">' +
          '<div class="w-12 h-12 sm:w-16 sm:h-16 rounded-md bg-white border border-slate-100 flex items-center justify-center shrink-0 overflow-hidden">' +
            '<img alt="' + REC.name + '" class="h-[125%] w-[125%] max-w-none object-contain drop-shadow-sm" loading="lazy" decoding="async" src="' + REC.img + '"></div>' +
          '<div class="flex-1 min-w-0"><div class="flex items-start justify-between gap-1.5">' +
            '<div class="min-w-0 flex flex-col items-start"><h3 class="font-bold text-xs sm:text-sm text-slate-900 leading-snug">' + REC.name + '</h3>' +
            '<span class="mt-0.5 inline-block rounded bg-[#d3def6] px-1.5 py-0.5 text-[10px] font-semibold text-[#3559a6]">' + REC.variant + '</span></div>' +
            '<span class="text-[9px] sm:text-[10px] font-bold tracking-wide bg-[#27599f]/10 text-[#27599f] px-1.5 py-0.5 rounded-full shrink-0 sm:px-2">Recommended</span></div>' +
          '<div class="mt-1.5 sm:mt-3 flex items-center justify-between gap-2"><span class="text-xs sm:text-sm font-bold text-slate-900">' + money(REC.price) + '</span>' +
            '<button data-cart-rec class="inline-flex items-center gap-1 rounded-full bg-[#1A1A1A] px-3 py-1 text-[11px] font-semibold text-white transition-colors hover:bg-[#2A2A2A] sm:gap-1.5 sm:px-4 sm:py-1.5 sm:text-xs">+ Add</button></div>' +
          '</div></div></div>';
      foot.innerHTML = recHtml +
        '<div><div class="flex gap-2"><input id="formera-cart-promo" data-cart-promo placeholder="Promo code" autocomplete="off" value="' + (disc ? disc.code : '') + '" class="flex-1 min-w-0 rounded-lg border border-slate-300 bg-white px-2.5 py-1.5 text-base sm:px-3 sm:py-2 sm:text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-formera-cyan focus:ring-2 focus:ring-formera-cyan/30" type="text">' +
          '<button data-cart-promo-apply class="shrink-0 rounded-lg bg-gradient-to-r from-[#1f4f97] via-[#27599f] to-[#2f6ac6] px-3 py-1.5 text-xs font-semibold text-white transition-all hover:brightness-110 disabled:opacity-60 sm:px-4 sm:py-2 sm:text-sm">Apply</button></div>' +
        '<div data-cart-promo-msg class="mt-1 text-[11px] font-semibold" style="display:none"></div></div>' +
        '<div class="flex items-center justify-between"><span class="font-bold text-xs sm:text-sm">Subtotal</span><span class="font-bold text-xs sm:text-sm">' + money(sub) + '</span></div>' +
        (disc ? '<div class="flex items-center justify-between"><span class="font-semibold text-xs text-[#1f7a4d] sm:text-sm">DISCOUNT &middot; ' + disc.code + '</span>' + '<span class="font-semibold text-xs text-[#1f7a4d] sm:text-sm">-' + money(disc.amountOff) + '</span></div>' : '') +
        '<div class="flex items-center justify-between"><span class="font-semibold text-xs text-slate-700 sm:text-sm">FREE USPS Express 1-2 Day Shipping</span>' +
          '<span class="font-semibold text-xs text-[#4a8dff] sm:text-sm">' + (ship ? money(ship) : 'FREE') + '</span></div>' +
        '<div class="flex items-center justify-between border-t border-slate-200 pt-1.5 sm:pt-2"><span class="font-bold text-sm sm:text-base">Total</span>' +
          '<span class="font-bold text-sm sm:text-base">' + money(Math.max(0, sub + ship - (disc ? Number(disc.amountOff)||0 : 0))) + '</span></div>' +
        '<a href="' + checkoutUrl() + '" data-formera-checkout class="w-full inline-flex items-center justify-center gap-1.5 bg-gradient-to-r from-[#1f4f97] via-[#27599f] to-[#2f6ac6] text-white text-sm font-semibold py-2.5 rounded-full transition-all hover:brightness-110 sm:gap-2 sm:py-3">Proceed to Checkout ' + arrow + '</a>' +
        '<div class="flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 sm:gap-x-2.5 sm:gap-y-1.5">' +
          '<div class="flex items-center gap-1.5 sm:gap-2.5" aria-hidden="true">' + CARDS + '</div>' +
          '<span class="text-[10px] sm:text-[11px] text-slate-500 inline-flex items-center gap-1">100% secure payments</span></div>';

      /* ── promo Apply: bind the controls that shipped dead ─────────────────────────────────── */
      var pIn  = foot.querySelector('[data-cart-promo]');
      var pBtn = foot.querySelector('[data-cart-promo-apply]');
      var pMsg = foot.querySelector('[data-cart-promo-msg]');
      function pFeedback(msg, ok){
        if(!pMsg) return;
        pMsg.textContent = msg || '';
        pMsg.style.color = ok ? '#1f7a4d' : '#c0392b';
        pMsg.style.display = msg ? 'block' : 'none';
      }
      if (disc) pFeedback('\u2713 ' + (disc.label || disc.code) + ' applied', true);
      var pBusy = false;
      function applyPromo(){
        if(!pIn || pBusy) return;
        var code = (pIn.value || '').trim();
        if(!code){ setCartDiscount(null); pFeedback('', true); self.render(); return; }
        var line = self.items();
        if(!line.length){ pFeedback('Your cart is empty.', false); return; }
        pBusy = true; if(pBtn) pBtn.disabled = true; pFeedback('Checking\u2026', true);
        /* the worker prices the code against the REAL line items — one pricing authority */
        fetch(FORMERA_CHECKOUT_ORIGIN + '/api/discount', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ code: code, items: line.map(function(i){
            return { sku:i.sku, name:i.name, variant:i.variant, price:i.price, qty:i.qty, variant_id:i.variant_id };
          })})
        })
        .then(function(r){ return r.json(); })
        .then(function(d){
          pBusy = false; if(pBtn) pBtn.disabled = false;
          if(d && d.ok && Number(d.amountOff) > 0){
            setCartDiscount({ code:d.code, amountOff:d.amountOff, label:d.label || d.code,
                              kind:d.kind || '', freeUnits:d.freeUnits || [], sig:cartSig(line) });
            self.render();   /* re-render paints the discount row, the new Total and the \u2713 */
          } else {
            /* \u26a0\ufe0f ORDER MATTERS: self.render() rebuilds this whole footer, which destroys the message
               element. Setting the message first and rendering after wiped it, so a rejected code
               (e.g. a buy-2-get-1 cart that has not reached 3 items) showed the shopper NOTHING.
               Repaint only if the stored state actually changed, then write the message last. */
            var had = !!cartDiscount();
            setCartDiscount(null);
            if (had) self.render();
            pFeedback((d && d.error) || 'That code can\u2019t be applied.', false);
          }
        })
        .catch(function(){ pBusy=false; if(pBtn) pBtn.disabled=false;
                           pFeedback('Couldn\u2019t check that code \u2014 try again.', false); });
      }
      if(pBtn) pBtn.onclick = function(e){ e.preventDefault(); applyPromo(); };
      if(pIn)  pIn.onkeydown = function(e){ if(e.key === 'Enter'){ e.preventDefault(); applyPromo(); } };

      var recBtn = foot.querySelector('[data-cart-rec]');
      if (recBtn) recBtn.onclick = function () { self.add(REC); };
      $$('[data-sku]', this.body).forEach(function (row) {
        var sku = row.getAttribute('data-sku');
        var cur = function () { return (self.items().filter(function (i) { return i.sku === sku; })[0] || {}).qty || 0; };
        var d = $('[data-cart-dec]', row), u = $('[data-cart-inc]', row), r = $('[data-cart-rm]', row);
        if (d) d.onclick = function (ev) { ev.stopPropagation(); self.setQty(sku, cur() - 1); };
        if (u) u.onclick = function (ev) { ev.stopPropagation(); self.setQty(sku, cur() + 1); };
        if (r) r.onclick = function (ev) { ev.stopPropagation(); self.setQty(sku, 0); };
      });
    }
  };

  /* Selected/unselected class sets captured VERBATIM from the live original (brand tokens renamed
     ascend-*→formera-* to match our stylesheet). Using anything else = classes with no CSS rule,
     which is why hand-invented selection styling read as "non-responsive". */
  var SEL = {
    size: {
      on:  ['bg-white', 'text-formera-navy-deep', 'shadow-[0_0_22px_rgba(127,211,255,0.45)]'],
      off: ['border', 'border-white/25', 'bg-white/[0.06]', 'text-white/70', 'hover:text-white', 'hover:border-white/50']
    },
    tier: {
      on:  ['border-formera-cyan', 'bg-white/[0.12]', 'ring-1', 'ring-formera-cyan/60', 'shadow-[0_0_18px_rgba(127,211,255,0.25)]'],
      off: ['border-white/15', 'bg-white/[0.05]', 'hover:border-white/35', 'hover:bg-white/[0.08]']
    },
    card: {  /* light-surface controls (product cards / size panels) */
      on:  ['border-gray-900', 'bg-gray-900', 'text-white'],
      off: ['border-gray-200', 'bg-white', 'text-gray-900']
    }
  };
  function markSelected(el, on, kind) {
    if (!el) return;
    var k = SEL[kind] || SEL.card;
    if (on) {
      k.off.forEach(function (c) { el.classList.remove(c); });
      k.on.forEach(function (c) { el.classList.add(c); });
      el.classList.add('is-selected');
      el.setAttribute('aria-pressed', 'true');
    } else {
      k.on.forEach(function (c) { el.classList.remove(c); });
      k.off.forEach(function (c) { el.classList.add(c); });
      el.classList.remove('is-selected');
      el.setAttribute('aria-pressed', 'false');
    }
  }

  /* ---- context helpers for add-to-cart ---- */
  function cardOf(el) { return el.closest('article, div[class*="rounded-2xl"], div[class*="rounded-xl"]') || null; }
  function nameOf(scope) {
    var h = scope && $('h1, h2, h3, .product-card__name', scope);
    return h ? text(h) : norm(($('h1') && text($('h1'))) || document.title.split('|')[0]);
  }
  function imgOf(scope) { var i = scope && $('img', scope); return i ? i.getAttribute('src') : ($('img[class*="object-contain"]') || {}).src || ''; }

  /* PDP state (selected variant + tier) */
  var PDP = { variant: '', price: null, tier: 1, qty: 1, sku: '', product: null };

  /* ========================= SIZE PANELS (product cards) ========================= */
  function panelInCard(card) {
    if (!card) return null;
    return $$('div', card).filter(function (d) {
      var c = (d.className || '') + '';
      return /absolute/.test(c) && /bottom-0/.test(c) && /translate-y/.test(c);
    })[0] || null;
  }

  /* ========================= PARTICLES (drive THEIR canvas) ========================= */
  function initParticles() {
    /* The original site ships its own full-page canvas: `fixed inset-0 z-0 pointer-events-none`.
       On pages where it exists we DRIVE it (never add a second one — a duplicate reads as a
       stray transparent box). Where the page lacks it, inject one with the same classes. */
    var cv = $$('canvas').filter(function (c) {
      var cl = (c.className || '') + '';
      return /fixed/.test(cl) && /inset-0/.test(cl);
    })[0];
    if (!cv) {
      cv = document.createElement('canvas');
      cv.className = 'fixed inset-0 z-0 pointer-events-none';
      cv.setAttribute('aria-hidden', 'true');
      if (document.body.firstChild) document.body.insertBefore(cv, document.body.firstChild);
      else document.body.appendChild(cv);
    }
    if (cv.__formeraDriven) return;
    cv.__formeraDriven = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ctx = cv.getContext('2d'); if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, ps = [], raf = null, running = false, t = 0;

    function size() {
      /* Round 5: NEVER trust cv.clientWidth here — the captured canvas shipped an inline
         width:1440px;height:1000px, so this measured 1440 forever and the gradient stopped
         dead at 1440px on any wider screen.  The viewport is the only source of truth. */
      w = window.innerWidth  || document.documentElement.clientWidth  || cv.clientWidth;
      h = window.innerHeight || document.documentElement.clientHeight || cv.clientHeight;
      cv.style.width = '100%'; cv.style.height = '100%';
      cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.min(90, Math.max(28, Math.round(w * h / 18000)));
      ps = [];
      for (var i = 0; i < n; i++) ps.push({
        x: Math.random() * w, y: Math.random() * h, r: 0.7 + Math.random() * 1.9,
        vx: (Math.random() - 0.5) * 0.14, vy: -0.05 - Math.random() * 0.20,
        a: 0.20 + Math.random() * 0.55, tw: Math.random() * 6.283, ts: 0.5 + Math.random()
      });
    }
    function frame() {
      t += 0.016; ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < ps.length; i++) {
        var p = ps[i];
        p.x += p.vx; p.y += p.vy;
        if (p.y < -4) { p.y = h + 4; p.x = Math.random() * w; }
        if (p.x < -4) p.x = w + 4; else if (p.x > w + 4) p.x = -4;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = 'rgba(255,255,255,' + (p.a * (0.6 + 0.4 * Math.sin(t * p.ts + p.tw))).toFixed(3) + ')';
        ctx.fill();
      }
      if (running) raf = requestAnimationFrame(frame);
    }
    function start() { if (!running && !reduce) { running = true; raf = requestAnimationFrame(frame); } }
    function stop()  { running = false; if (raf) cancelAnimationFrame(raf); raf = null; }
    size();
    if (reduce) { frame(); return; }
    start();
    window.addEventListener('resize', size);
    window.addEventListener('orientationchange', function () { setTimeout(size, 120); });
    window.addEventListener('load', function () { size(); start(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
  }

  /* ========================= ONE DELEGATED CLICK ROUTER =========================
     Every button on every page is routed here by aria-label first, then by text.
     Delegation means late-rendered nodes (cart rows, panels) are covered too.     */
  function route(e) {
    var el = e.target && e.target.closest ? e.target.closest('button, a[role="button"], summary') : null;
    if (!el) return;
    var L = (label(el) || '').toLowerCase();
    var T = text(el);
    var Tl = T.toLowerCase();

    /* ---- chrome: drawers & overlays ---- */
    /* quantity stepper on the PDP (cart rows have their own handlers bound directly) */
    if ((L === 'increase quantity' || L === 'decrease quantity') && !el.closest('aside[aria-label="Shopping Cart"]')) {
      e.preventDefault();
      setQty((PDP.qty || 1) + (L === 'increase quantity' ? 1 : -1));
      return;
    }
    if (L === 'open cart')      { e.preventDefault(); Cart.open(); return; }
    if (L === 'close cart')     { e.preventDefault(); Cart.close(); return; }
    if (L === 'open wishlist' || Tl === 'my wishlist') {
      e.preventDefault();
      var wa = asideBy('Wishlist') || asideBy('My Wishlist');
      if (wa) { renderWishlist(wa); slideOpen(wa); anyScrimOn(); } return;
    }
    if (L === 'remove from wishlist') {
      e.preventDefault();
      var nmw = el.getAttribute('data-name') || '';
      var lstw = read(LS_WISH, []); var ixw = lstw.indexOf(nmw);
      if (ixw > -1) { lstw.splice(ixw, 1); write(LS_WISH, lstw); }
      var wa2 = asideBy('Wishlist') || asideBy('My Wishlist');
      if (wa2) renderWishlist(wa2);
      return;
    }
    if (L === 'close wishlist') { e.preventDefault(); var w2 = asideBy('Wishlist') || asideBy('My Wishlist'); slideShut(w2); anyScrimOff(); return; }
    if (L === 'toggle menu')    { e.preventDefault(); slideOpen(asideBy('Menu')); anyScrimOn(); lock(true); return; }
    if (L === 'close menu')     { e.preventDefault(); slideShut(asideBy('Menu')); anyScrimOff(); lock(false); return; }
    if (L === 'search')         { e.preventDefault(); Search.open(); return; }
    if (L === 'close search')   { e.preventDefault(); Search.close(); return; }
    if (L === 'close size selector') { e.preventDefault(); panelOff(el.closest('div[class*="absolute"]')); return; }

    /* ---- carousel arrows (PDP "Frequently bought together" etc.) ----
       Verified against the original: one click scrolls the overflow-x track by ~its client width. */
    if (L === 'scroll right' || L === 'scroll left') {
      e.preventDefault();
      var node = el.parentElement, track = null;
      while (node && !track) {
        track = $$('div', node).filter(function (d) { return d.scrollWidth > d.clientWidth + 20; })[0] || null;
        node = node.parentElement;
      }
      if (track) {
        var step = track.clientWidth || 600;
        track.scrollBy({ left: (L === 'scroll right' ? step : -step), behavior: 'smooth' });
      }
      return;
    }
    if (L === 'add to wishlist') {
      e.preventDefault();
      var c = cardOf(el), nm = nameOf(c); if (!nm) return;
      var list = read(LS_WISH, []); var ix = list.indexOf(nm);
      if (ix > -1) list.splice(ix, 1); else list.push(nm);
      write(LS_WISH, list); el.classList.toggle('is-active', list.indexOf(nm) > -1);
      return;
    }
    if (L === 'show password' || Tl === 'show password') {
      e.preventDefault();
      var pw = $('input[type="password"]') || $('input[type="text"][name*="pass" i]');
      if (pw) pw.type = pw.type === 'password' ? 'text' : 'password';
      return;
    }

    /* ---- CARD size-panel chip (collection / home / search / "frequently bought" grids) ----
       🔴 Dom QA 2026-08-02 — these NEVER worked. The PDP branch below requires the button text to be
       ONLY a size (/^\d+\s*(mg|iu)$/) AND to contain no price. But a card chip renders as
       "10mg$155.00" — snippets/product-card.liquid puts the size and the price in the SAME button —
       so priceIn(T) was truthy and the branch was skipped on every click. It also could not match
       `ml` (Bac Water) or compound doses ("10/10/50mg", "5/5mg", "13/3mg").
       This was not cosmetic: the panel's "Add to cart — $X" confirm reads the `.is-selected` chip,
       and because selection never moved off the first one, the card ADDED THE FIRST VARIANT no
       matter which size the shopper chose. Identify these chips structurally instead — they are the
       only buttons carrying data-variant-id inside a product card. */
    if (el.getAttribute && el.getAttribute('data-variant-id') && el.closest('[data-handle]')) {
      e.preventDefault();
      var chipPanel = el.parentElement;
      $$('button', chipPanel).forEach(function (s2) {
        if (s2.getAttribute('data-variant-id')) markSelected(s2, false, 'card');
      });
      markSelected(el, true, 'card');
      /* keep the confirm button's price in step with the chosen size */
      var chipCard = el.closest('[data-handle]');
      var chipPrice = parseFloat(el.getAttribute('data-price'));
      if (!isNaN(chipPrice) && chipCard) {
        $$('button', chipCard).forEach(function (cb) {
          if (!/add to cart/i.test(cb.textContent || '')) return;
          var spans = $$('span', cb);
          var last = spans[spans.length - 1];
          if (last && /^\$/.test((last.textContent || '').trim())) {
            last.textContent = '$' + chipPrice.toFixed(2);
          }
        });
      }
      return;
    }

    /* ---- PDP: size / dosage selection (aria-label "Select size 10mg") ---- */
    if (/^select size/i.test(L) || (/^\d+\s*(mg|ml|iu)$/i.test(T) && !priceIn(T))) {
      e.preventDefault();
      var group = el.parentElement ? $$('button', el.parentElement) : [];
      group.forEach(function (s) { markSelected(s, false, 'size'); });
      markSelected(el, true, 'size');
      PDP.variant = T || L.replace(/select size/i, '').trim();
      var dp = parseFloat(el.getAttribute('data-price'));
      if (!isNaN(dp)) PDP.price = dp;
      var ds = el.getAttribute('data-sku'); if (ds) PDP.sku = ds;
      var dv = el.getAttribute('data-variant-id'); if (dv) PDP.variant_id = dv;
      if (dv) showVariantImage(dv, el);
      var sizeLbl = document.querySelector('[data-formera-size]');
      if (sizeLbl) sizeLbl.textContent = PDP.variant;
      syncPdpPrice();
      return;
    }
    /* ---- PDP: multi-vial tier ("2 Vials3% off", "BEST VALUE3 Vials5% off", "5+ Vials8% off") ----
       NOTE: no trailing \b after "vial" — the rendered text runs together ("Vials5% off"). */
    if (/\bvial/i.test(T)) {
      e.preventDefault();
      var sibs = el.parentElement ? $$('button', el.parentElement) : [];
      sibs.forEach(function (s) { markSelected(s, false, 'tier'); });
      markSelected(el, true, 'tier');
      var q = T.match(/(\d+)\s*\+?\s*vial/i);
      PDP.tier = q ? parseInt(q[1], 10) : 1;
      syncPdpPrice();
      return;
    }

    /* ---- size-panel confirm: "Add to cart — $65.00" ---- */
    var pr = priceIn(T);
    if (/^add to cart/i.test(Tl) && pr !== null) {
      e.preventDefault();
      var card1 = cardOf(el);
      var pnl = el.closest('div[class*="absolute"]');
      /* take the variant from the chip actually selected in THIS panel (PDP.variant only applies
         on the product page); otherwise the cart row renders "Remove NAME - " with no size. */
      var chosen = '';
      if (pnl) {
        var selChip = $$('button', pnl).filter(function (b) { return b.classList.contains('is-selected'); })[0]
                   || $$('button', pnl).filter(function (b) { return /\d+\s*(mg|ml|iu)/i.test(text(b)); })[0];
        if (selChip) chosen = text(selChip).split('$')[0].trim();
      }
      var vlabel = chosen || PDP.variant || '';
      var vid = selChip && selChip.getAttribute ? selChip.getAttribute('data-variant-id') : null;
      var vsku = selChip && selChip.getAttribute ? selChip.getAttribute('data-sku') : null;
      Cart.add({ sku: vsku || (nameOf(card1) + '|' + (vlabel || 'default')), name: nameOf(card1),
                 variant: vlabel, price: pr, img: imgOf(card1), variant_id: vid });
      panelOff(pnl);
      return;
    }
    /* ---- size option inside a panel: "10mg $65.00" ---- */
    if (/^\d+\s*(mg|iu|ml)\b/i.test(T) && pr !== null) {
      e.preventDefault();
      var card2 = cardOf(el);
      var variant = T.split('$')[0].trim();
      Cart.add({ sku: el.getAttribute('data-sku') || (nameOf(card2) + '|' + variant), name: nameOf(card2),
                 variant: variant, price: pr, img: imgOf(card2),
                 variant_id: el.getAttribute('data-variant-id') });
      panelOff(el.closest('div[class*="absolute"]'));
      return;
    }
    /* ---- plain "Add to cart" ---- */
    if (/^add to cart$/i.test(Tl)) {
      e.preventDefault();
      var card3 = cardOf(el);
      var panel = panelInCard(card3);
      if (panel) { panelOn(panel); return; }               // card → reveal size options
      var price = PDP.price;                                // PDP → add selected variant
      if (price === null) {
        var pe = $('[class*="text-3xl"], [class*="text-2xl"]');
        price = pe ? priceIn(text(pe)) : null;
      }
      if (PDP.product) {
        var pct2 = tierPctFor(PDP.tier || 1);
        var vsel = $$('button').filter(function (b) { return /^select size/i.test(label(b)) && b.classList.contains('is-selected'); })[0];
        Cart.add({ sku: PDP.sku || (PDP.product.name + '|' + PDP.variant),
                   name: PDP.product.name, variant: PDP.variant || '',
                   price: PDP.price * (1 - pct2 / 100),
                   /* the CHOSEN variant's image, not the product's featured one — otherwise every
                      dosage of a product shows the same thumbnail in the cart and at checkout */
                   img: ((PDP.product.sizes || []).filter(function (z) { return z.label === PDP.variant; })[0] || {}).img
                        || PDP.product.img,
                   variant_id: (vsel && vsel.getAttribute('data-variant-id')) ||
                               ((PDP.product.sizes.filter(function(z){return z.label===PDP.variant;})[0]||{}).variant_id),
                   qty: (PDP.tier || 1) * (PDP.qty || 1) });
        return;
      }
      if (price === null) price = priceIn(document.body.innerText) || 0;
      var nm3 = nameOf(null);
      Cart.add({ sku: nm3 + '|' + (PDP.variant || 'default'), name: nm3, variant: PDP.variant || '',
                 price: price, img: imgOf(null), qty: PDP.tier || 1 });
      return;
    }

    /* ---- COA card -> lightbox modal (replicated from the original CoaLightbox) ---- */
    if (/^view coa reports for /i.test(L)) {
      e.preventDefault();
      openCoaLightbox((label(el) || '').replace(/^View COA reports for\s*/i, '').trim());
      return;
    }
    if (L === 'close preview') { e.preventDefault(); var lb = $('#formera-coa-lightbox'); if (lb) lb.remove(); lock(false); return; }

    /* ---- accordions (FAQ / contact) ----
       COA rows identify via aria-label ("View COA reports for GLP-3 RT"), NOT via their text,
       which is the product name + size count. Match on BOTH label and text. */
    if (el.hasAttribute('aria-expanded') || /^(view coa|view report)/i.test(L) ||
        /^(view report|view reports|view coa)/i.test(Tl) ||
        (el.tagName === 'BUTTON' && /\?$/.test(T))) {
      var open = el.getAttribute('aria-expanded') === 'true';
      el.setAttribute('aria-expanded', open ? 'false' : 'true');
      var id = el.getAttribute('aria-controls');
      var pane = id ? document.getElementById(id) : el.nextElementSibling;
      /* some rows wrap the panel a level up (button and panel are siblings inside a row wrapper) */
      if (!pane && el.parentElement) pane = el.parentElement.nextElementSibling;
      /* Round 5: the reference's panels are CSS-grid accordions —
         `grid transition-all duration-300 ease-out grid-rows-[0fr] opacity-0` collapsed,
         `grid-rows-[1fr] opacity-100` expanded.  Toggling display/hidden (what this used to do)
         changed nothing visible, so every FAQ / Product-Description panel looked dead.
         Both classes ARE compiled in styles.css — verified before relying on them. */
      if (pane && /grid-rows-\[/.test((pane.className || '') + '')) {
        pane.classList.toggle('grid-rows-[0fr]', open);
        pane.classList.toggle('grid-rows-[1fr]', !open);
        pane.classList.toggle('opacity-0', open);
        pane.classList.toggle('opacity-100', !open);
      } else if (pane) {
        if (pane.hasAttribute('hidden')) pane.hidden = open;
        else { pane.style.display = open ? 'none' : ''; pane.classList.toggle('hidden', open); }
      }
      /* chevron: the reference points it left when collapsed, down when expanded */
      var chev = el.querySelector('svg.lucide-chevron-down');
      if (chev) chev.classList.toggle('-rotate-90', open);
      return;
    }

    /* ---- OAuth / password-reset: MUST be tested before the generic submit branch below,
           otherwise "Sign in with Google" is swallowed by /^sign in/. ---- */
    if (/^(sign in with |forgot password)/i.test(Tl)) {
      e.preventDefault();
      var oh = el.closest('form') || el.parentElement || el.closest('div');
      if (oh) {
        var on_ = oh.querySelector('[data-formera-note]');
        if (!on_) {
          on_ = document.createElement('p');
          on_.setAttribute('data-formera-note', '1');
          on_.className = 'mt-3 text-sm font-semibold text-[#27599f]';
          oh.appendChild(on_);
        }
        on_.textContent = T + ' — backend wiring pending.';
      }
      return;
    }

    /* ---- forms: submit-style buttons give feedback instead of dead-clicking ---- */
    if (/^(submit message|track order|sign in|subscribe|send message)/i.test(Tl)) {
      var form = el.closest('form');
      if (form) {
        e.preventDefault();
        var ok = form.querySelector('[data-formera-note]');
        if (!ok) {
          ok = document.createElement('p');
          ok.setAttribute('data-formera-note', '1');
          ok.className = 'mt-3 text-sm font-semibold text-[#27599f]';
          form.appendChild(ok);
        }
        ok.textContent = 'Submitted — backend wiring pending.';
      }
      return;
    }
  }

  function syncPdpPrice() {
    if (PDP.price === null || PDP.price === undefined) return;
    var units = (PDP.tier || 1) * (PDP.qty || 1);
    var pct = tierPctFor(PDP.tier || 1);
    var unit = PDP.price * (1 - pct / 100);
    var total = unit * units;
    /* the big buybox price (their node renders "$" + the number as separate text nodes) */
    var big = document.querySelector('[data-formera-pdp-price]') ||
              $$('span').filter(function (e) { return /text-3xl/.test((e.className || '') + '') && /\$/.test(text(e)); })[0];
    if (big) big.textContent = money(total);
    /* any "Add to cart — $X" label */
    $$('button').forEach(function (b) {
      if (/^add to cart/i.test(text(b)) && /\$/.test(text(b))) {
        b.textContent = b.textContent.replace(/\$[\d,.]+/, money(total));
      }
    });
  }

  /* wishlist drawer contents — same row pattern as the replicated cart, plus Remove */
  function renderWishlist(aside) {
    var body = $('.flex-1.overflow-y-auto', aside) || aside.children[1];
    if (!body) return;
    if (!aside.__emptyTpl) aside.__emptyTpl = body.innerHTML;
    var names = read(LS_WISH, []);
    if (!names.length) { body.innerHTML = aside.__emptyTpl; return; }
    withCatalog(function (cat) {
      body.innerHTML = '<ul class="space-y-2">' + names.map(function (n) {
        var p = cat.filter(function (x) { return x.name === n; })[0] || { name: n, img: '', price: 0, sku: '' };
        return '<li class="flex gap-2.5 items-center p-2 rounded-xl border border-slate-100 bg-white hover:border-slate-200 transition-colors">' +
          '<div class="w-20 h-20 rounded-md bg-slate-50 border border-slate-100 flex items-center justify-center shrink-0 overflow-hidden">' +
            (p.img ? '<img alt="' + p.name + '" class="h-[125%] w-[125%] max-w-none object-contain drop-shadow-sm" src="' + assetUrl(p.img) + '">' : '') + '</div>' +
          '<div class="flex-1 min-w-0"><div class="flex items-start justify-between gap-2">' +
            '<h3 class="max-w-full font-bold text-sm text-slate-900 leading-snug truncate">' + p.name + '</h3>' +
            '<button data-name="' + p.name + '" aria-label="Remove from wishlist" class="text-slate-400 hover:text-red-600 transition-colors shrink-0">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4" aria-hidden="true"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg></button></div>' +
            '<div class="mt-1.5 flex items-center justify-between gap-2">' +
              '<span class="text-sm font-bold text-slate-900">' + (p.price ? money(p.price) : '') + '</span>' +
              '<a href="/products/' + (p.sku || '') + '" class="inline-flex items-center gap-1 rounded-full bg-[#1A1A1A] px-3 py-1 text-[11px] font-semibold text-white hover:bg-[#2A2A2A]">View</a>' +
            '</div></div></li>';
      }).join('') + '</ul>';
    });
  }

  /* COA lightbox — same structure/classes as the original modal */
  /* Which lab(s) actually tested the reports on screen. Dom 2026-08-02: Kovera Labs did the 10 new
     8x COAs, Freedom Diagnostics did every earlier one — and most products now hold BOTH, so no
     surface may hardcode a single lab. Newest lab first (that is the one the shopper sees at the top
     of the report list). */
  function testedByLine(variants) {
    var labs = [], seen = {};
    Object.keys(variants || {}).forEach(function (k) {
      (variants[k] || []).forEach(function (r) {
        if (r && r.lab && !seen[r.lab]) { seen[r.lab] = 1; labs.push(r.lab); }
      });
    });
    /* Deterministic order — object key order made GHK-Cu and TB-500 read
       "Freedom Diagnostics & Kovera Labs" while every other product read the reverse (their Kovera
       report sits under the "(size not stated)" key, so first-seen differed). Newest testing round
       first; anything unrecognised falls to the end alphabetically. */
    var RANK = { 'Kovera Labs': 0, 'Freedom Diagnostics': 1 };
    labs.sort(function (a, b) {
      var ra = RANK[a] === undefined ? 99 : RANK[a], rb = RANK[b] === undefined ? 99 : RANK[b];
      return ra - rb || a.localeCompare(b);
    });
    if (!labs.length) return 'Independently 8x Tested';
    if (labs.length === 1) return 'Independently 8x Tested by ' + labs[0];
    return 'Independently 8x Tested by ' + labs.slice(0, -1).join(', ') + ' &amp; ' + labs[labs.length - 1];
  }

  /* The PDP's COA panel ships a STATIC header in templates/product.liquid, which cannot know which
     labs apply. Rewrite it from the data once the panel is rendered; the Liquid default is deliberately
     lab-free so a JS failure can never leave a false lab claim on screen. */
  function paintPdpTestedBy(variants) {
    var panel = document.getElementById('coa-panel');
    if (!panel) return;
    var p = [].slice.call(panel.querySelectorAll('p')).filter(function (n) {
      return /independently 8x tested/i.test(n.textContent || '');
    })[0];
    if (p) p.innerHTML = testedByLine(variants);
  }

  function openCoaLightbox(name) {
    /* Round 7: opens the REAL hosted COA (Shopify Files) instead of a placeholder.
       window.FORMERA_COA is rendered by snippets/coa-data.liquid: { handle: { variant: [{lot,url}] } }.
       Only products/variants we actually hold a COA for are in it — nothing is invented. */
    var COA = window.FORMERA_COA || {};
    /* 🔴 Dom QA 2026-08-02: "View COA does nothing". This map used to be NINE HARD-CODED titles —
       the original COA products. The archive was later rebuilt from window.FORMERA_COA (14 products),
       so the 5 newer ones (ARA-290, Bac Water, BPC-157, CJC-1295 + Ipamorelin, Tesamorelin +
       Ipamorelin) resolved to no handle, `labels` came back empty and the function returned
       silently — a click that looked completely dead. Same class of bug as the frozen archive grid.
       Now driven by FORMERA_COA_TITLES (emitted from coa-data.liquid alongside the COA data itself),
       so title→handle can never fall behind the catalogue again. */
    var TITLES = window.FORMERA_COA_TITLES || {};
    var want = String(name || '').trim().toLowerCase();
    var handle = null;
    for (var hk in TITLES) { if (String(TITLES[hk]).trim().toLowerCase() === want) { handle = hk; break; } }
    if (!handle) { for (var hk2 in COA) { if (hk2.toLowerCase() === want) { handle = hk2; break; } } }
    if (!handle && COA[name]) handle = name;
    var variants = handle ? (COA[handle] || {}) : {};
    var labels = Object.keys(variants);
    if (!labels.length) return;

    var old = document.getElementById('formera-coa-lightbox'); if (old) old.remove();
    var wrap = document.createElement('div');
    wrap.id = 'formera-coa-lightbox';
    wrap.className = 'fixed inset-0 z-[120] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4';
    wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true');

    function chips(active) {
      return labels.map(function (l) {
        var on = l === active;
        return '<button type="button" data-coa-size="' + l.replace(/"/g, '&quot;') + '" aria-pressed="' + on + '" ' +
          'class="shrink-0 rounded-full border px-3 py-1 text-xs font-semibold transition-colors ' +
          (on ? 'border-[#2a6ad0] bg-[#2a6ad0] text-white' : 'border-slate-300 bg-white text-slate-700 hover:border-slate-500') +
          '">' + l + '</button>';
      }).join('');
    }
    function reports(l) {
      return (variants[l] || []).map(function (r, ix) {
        return '<a href="' + r.url + '" target="_blank" rel="noopener" ' +
          'class="flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-3 hover:border-[#2a6ad0] transition-colors">' +
          '<span class="text-sm font-semibold text-slate-900">' + (TITLES[handle] || name) + ' ' + l +
          (r.lot ? ' <span class="font-normal text-slate-500">&middot; lot ' + r.lot + '</span>' : '') +
          (r.lab ? ' <span class="font-normal text-slate-500">&middot; ' + r.lab + '</span>' : '') + '</span>' +
          '<span class="text-xs font-bold text-[#2a6ad0]">OPEN PDF &rarr;</span></a>';
      }).join('');
    }
    function paint(active) {
      wrap.innerHTML =
        '<div class="w-full max-w-2xl rounded-2xl bg-white shadow-2xl overflow-hidden">' +
          '<div class="flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4">' +
            '<div><h3 class="text-base font-bold tracking-tight text-slate-900">' + (TITLES[handle] || name) +
            ' &mdash; Certificate of Analysis</h3>' +
            '<p class="mt-0.5 text-xs text-slate-500">' + testedByLine(variants) + '</p></div>' +
            '<button type="button" aria-label="Close preview" class="rounded-full p-1 text-slate-400 hover:text-slate-900">&#10005;</button>' +
          '</div>' +
          '<div class="px-5 py-4">' +
            '<div class="flex flex-wrap gap-2 mb-4">' + chips(active) + '</div>' +
            '<div class="space-y-2">' + reports(active) + '</div>' +
          '</div>' +
        '</div>';
      $$('[data-coa-size]', wrap).forEach(function (b) {
        b.addEventListener('click', function () { paint(b.getAttribute('data-coa-size')); });
      });
      var x = wrap.querySelector('[aria-label="Close preview"]');
      if (x) x.addEventListener('click', function () { wrap.remove(); lock(false); });
    }
    paint(labels[0]);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) { wrap.remove(); lock(false); } });
    document.body.appendChild(wrap); lock(true);
  }

  /* PDP COA rail — render one card per variant that ACTUALLY has a COA; if the product has none,
     the rail shows the archive pointer that ships in the template. */
  /* COA ARCHIVE — rebuilt from window.FORMERA_COA, the same source the PDP rail uses.
     🔴 Dom QA 2026-07-30 "many COAs are missing": the archive grid shipped as NINE HARD-CODED cards
     generated once by tools/fix_coa.py. Wiring new COAs updated the PDPs but the archive kept
     rendering its frozen list, so 5 products with real hosted COAs were invisible there. Driving it
     off the same JSON removes the possibility of that drift entirely. */
  function initCoaArchive() {
    var grid = document.querySelector('[data-coa-grid]');
    if (!grid) return;
    var data = window.FORMERA_COA || {};
    var titles = window.FORMERA_COA_TITLES || {};
    var handles = Object.keys(data).filter(function (h) {
      var v = data[h]; return v && Object.keys(v).length;
    });
    if (!handles.length) return;                       /* leave the captured markup alone */
    var tpl = grid.querySelector('button');
    if (!tpl) return;
    handles.sort(function (a, b) {
      return (titles[a] || a).localeCompare(titles[b] || b);
    });
    var frag = document.createDocumentFragment();
    handles.forEach(function (h) {
      var title = titles[h] || h;
      var reports = 0, variants = data[h];
      Object.keys(variants).forEach(function (k) { reports += (variants[k] || []).length; });
      var card = tpl.cloneNode(true);
      card.setAttribute('aria-label', 'View COA reports for ' + title);
      card.setAttribute('data-coa-handle', h);
      /* the captured card carries: icon, product name, and a "N reports" line */
      var leaves = [].slice.call(card.querySelectorAll('*')).filter(function (e) {
        return e.children.length === 0 && (e.textContent || '').trim();
      });
      if (leaves[0]) leaves[0].textContent = title;
      if (leaves[1]) leaves[1].textContent = reports + ' report' + (reports === 1 ? '' : 's');
      frag.appendChild(card);
    });
    grid.innerHTML = '';
    grid.appendChild(frag);
  }

  function initPdpCoa() {
    var rail = document.querySelector('[data-coa-rail]');
    if (!rail) return;
    var node = document.getElementById('formera-product-json');
    if (!node) return;
    var prod; try { prod = JSON.parse(node.textContent); } catch (e) { return; }
    var variants = (window.FORMERA_COA || {})[prod.handle];
    if (!variants || !Object.keys(variants).length) return;      // keep the empty-state copy
    var cards = Object.keys(variants).map(function (l) {
      var rs = variants[l] || [];
      return '<div data-coa-card="true" class="flex w-[280px] flex-col p-4 xl:p-3 shrink-0 xl:shrink xl:min-w-0 ' +
        'rounded-2xl border bg-white transition-[border-color,box-shadow] duration-300 ease-out border-slate-200 shadow-sm ' +
        'hover:border-[rgba(42,106,208,0.5)] hover:shadow-[0_0_20px_4px_rgba(42,106,208,0.18),0_4px_16px_rgba(0,0,0,0.05)]">' +
        '<div class="flex flex-wrap items-center gap-1.5">' +
          '<span class="inline-flex items-center rounded-md bg-[#141414] px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-white">Latest</span>' +
          '<span class="inline-flex items-center rounded-md bg-[#0f2f5f] px-2 py-0.5 text-[9px] font-bold uppercase tracking-wider text-white">8&times; Testing</span>' +
        '</div>' +
        '<div class="mt-3 text-center">' +
          '<div class="text-3xl font-extrabold tracking-tight text-emerald-600">99%+</div>' +
          '<div class="mt-0.5 text-[10px] font-semibold uppercase tracking-wider text-slate-500">Stated Purity Standard</div>' +
        '</div>' +
        '<dl class="mt-3 space-y-1.5 rounded-xl bg-slate-50 p-3 text-[11px]">' +
          '<div class="flex items-center justify-between gap-2"><dt class="text-slate-500">Variant</dt>' +
            '<dd class="text-right font-semibold text-slate-900">' + prod.title + ' ' + l + '</dd></div>' +
          '<div class="flex items-center justify-between gap-2"><dt class="text-slate-500">Reports</dt>' +
            '<dd class="font-semibold text-slate-900 tabular-nums">' + rs.length + '</dd></div>' +
        '</dl>' +
        '<button type="button" aria-label="View COA reports for ' + (prod.title || '').replace(/"/g, '&quot;') + '" ' +
          'class="mt-3 w-full rounded-full bg-[#141414] py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#2a6ad0]">View COA</button>' +
        '</div>';
    }).join('');
    rail.innerHTML = cards;
    paintPdpTestedBy(variants);
  }

  /* ========================= SEARCH ========================= */
  var Search = {
    input: null, wrap: null,
    init: function () {
      this.input = $('input[placeholder="Search for a product..."]');
      if (!this.input) return;
      var p = this.input.parentElement;
      while (p && p !== document.body) {
        var c = (p.className || '') + '';
        if (/fixed/.test(c) && (/z-\[/.test(c) || /z-\d/.test(c))) { this.wrap = p; break; }
        p = p.parentElement;
      }
      this.close();
      var self = this;
      this.input.addEventListener('input', function () {
        var q = self.input.value.trim().toLowerCase();
        $$('a[href^="product.html"]').forEach(function (a) {
          var row = a.closest('article, li, div[class*="rounded"]') || a;
          row.style.display = (!q || text(a).toLowerCase().indexOf(q) > -1) ? '' : 'none';
        });
      });
    },
    open:  function () { if (this.wrap) fadeOn(this.wrap); if (this.input) setTimeout(function () { Search.input.focus(); }, 30); },
    close: function () { if (this.wrap) fadeOff(this.wrap); }
  };

  /* ========================= PRODUCTS: filter + sort ========================= */
  function initProducts() {
    /* Use the LARGEST product grid — the search overlay also contains a small
       "Relevant Products" grid that would otherwise win. */
    var grid = $$('div[class*="grid"]')
      .map(function (g) { return { g: g, n: $$('a[href^="product.html"]', g).length }; })
      .filter(function (o) { return o.n > 3; })
      .sort(function (a, b) { return b.n - a.n; })
      .map(function (o) { return o.g; })[0];
    if (!grid) return;
    var cards = $$(':scope > div', grid);
    /* The filter pills are category NAMES, but each card's subtitle is a product descriptor
       ("Growth Hormone Peptide", "Tissue Repair Blend"...). Map pill -> descriptor keywords. */
    var CATMAP = {
      'all products': null,
      'metabolic research': /metabolic|glp|incretin|ampk/i,
      'gh research': /growth hormone|ghrh|secretagogue|igf|somatropin/i,
      'tissue repair research': /tissue repair|repair blend|healing/i,
      'cellular research': /cellular|longevity|coenzyme|mitochondri|copper|redox|antioxidant/i,
      'neuro research': /nootropic|neuro|cognitive|sleep/i,
      'bundles': /blend|bundle|stack|kit/i
    };
    var CATS = /^(All products|Metabolic Research|GH Research|Tissue Repair Research|Cellular Research|Neuro Research|Bundles)$/i;
    var pills = $$('button').filter(function (b) { return CATS.test(text(b)); });
    pills.forEach(function (p) {
      p.addEventListener('click', function (e) {
        e.preventDefault();
        var key = text(p).toLowerCase();
        var re = CATMAP.hasOwnProperty(key) ? CATMAP[key] : null;
        pills.forEach(function (o) { o.classList.toggle('is-active', o === p); });
        if (window.FORMERA_GRID) { window.FORMERA_GRID.filter(re); return; }
        cards.forEach(function (c) {
          var t = text(c);
          c.style.display = (!re || re.test(t)) ? '' : 'none';
        });
      });
    });
    var sel = $('select');
    if (sel) sel.addEventListener('change', function () {
      var v = (sel.value || sel.options[sel.selectedIndex].text || '').toLowerCase();
      if (window.FORMERA_GRID) { window.FORMERA_GRID.sort(v); return; }
      var arr = cards.slice();
      var pOf = function (c) { return priceIn(text(c)) || 0; };
      if (/low|asc/.test(v)) arr.sort(function (a, b) { return pOf(a) - pOf(b); });
      else if (/high|desc/.test(v)) arr.sort(function (a, b) { return pOf(b) - pOf(a); });
      arr.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ========================= PDP gallery ========================= */
  function initGallery() {
    var main = $('img[class*="object-contain"]');
    if (!main) return;
    $$('button').forEach(function (b) {
      var im = $('img', b);
      if (!im) return;
      b.addEventListener('click', function () {
        var s = im.getAttribute('src'); if (s) main.setAttribute('src', s);
      });
    });
    /* Round 7 — REMOVED a document-wide price scrape that used to live here:
         var pe = $$('*').filter(e => /^\$[\d,.]+$/.test(text(e)))[0]; PDP.price = priceIn(...)
       It took the FIRST `$NN.NN` node in DOM order, which on a product page is a card chip in the
       header's search overlay — a DIFFERENT product — and because initGallery() runs LAST in boot()
       it always clobbered the correct price initSkuRouting() had read from the Liquid product JSON.
       On a product page the price now has exactly ONE source: the Shopify product. */
  }

  /* ========================= CATALOG (our Shopify products) =========================
     assets/catalog.json is generated from the live Shopify export (records/shopify-created-products.json):
     real names, real per-variant prices, real SKUs + our vial art. Everything product-facing renders from
     it, so the site always matches Shopify. */
  var CATALOG = null;
  function withCatalog(fn) {
    if (CATALOG) { fn(CATALOG); return; }
    fetch(window.FORMERA_CATALOG_URL || assetUrl('catalog.json')).then(function (r) { return r.json(); })
      .then(function (c) { CATALOG = c; fn(c); }).catch(function () {});
  }
  function findSku(sku) {
    if (!CATALOG || !sku) return null;
    return CATALOG.filter(function (p) { return p.sku === sku; })[0] || null;
  }

  /* ---- products grid: render ALL catalog products + working pagination ----
     The capture only contains page 1 of the original grid (their React fetched pages 2-3), so
     "Next" had nothing to show. We re-render the grid from the catalog by CLONING an existing card
     node — that keeps their exact card markup/classes — and then paginate client-side. */
  var PAGE_SIZE = 16;
  function initCatalogGrid() {
    /* Round 5: the collection grid is server-rendered by Liquid ({% paginate %} + product-card
       snippet) and paginates via real links.  If those cards are present, this legacy client-side
       renderer must NOT run — it would replace correct Shopify data with catalog.json. */
    if (document.querySelector('[data-handle]')) return;
    var grid = $$('div[class*="grid"]')
      .map(function (g) { return { g: g, n: $$('a[href^="product.html"]', g).length }; })
      .filter(function (o) { return o.n > 3; })
      .sort(function (a, b) { return b.n - a.n; })
      .map(function (o) { return o.g; })[0];
    if (!grid) return;
    var tpl = $$(':scope > div', grid)[0];
    if (!tpl) return;
    var proto = tpl.cloneNode(true);

    withCatalog(function (cat) {
      function card(p) {
        var el = proto.cloneNode(true);
        /* links */
        $$('a[href^="product.html"]', el).forEach(function (a) {
          a.setAttribute('href', '/products/' + encodeURIComponent(p.sku));
          if (a.getAttribute('aria-label')) a.setAttribute('aria-label', 'View ' + p.name);
        });
        /* images: first img = primary, drop the rest of the crossfade stack */
        var imgs = $$('img', el);
        imgs.forEach(function (im, ix) {
          if (ix === 0) { im.setAttribute('src', assetUrl(p.img)); im.setAttribute('alt', p.name); im.style.opacity = '1'; }
          else if (im.closest('button')) { /* keep control icons */ }
          else im.remove();
        });
        /* name + price + subtitle */
        var h3 = $('h3', el); if (h3) h3.textContent = p.name;
        var priceEl = $$('span', el).filter(function (s) { return /^(From\s*)?\$[\d,.]+$/.test(text(s)); })[0];
        if (priceEl) priceEl.textContent = (p.sizes.length > 1 ? 'From ' : '') + money(p.price);
        var subEl = $$('p,span', el).filter(function (s) {
          return s.children.length === 0 && /Peptide|Blend|Coenzyme|Compound|Diluent|Analog|Complex|Research/i.test(text(s))
                 && text(s).length < 46 && !/\$/.test(text(s));
        })[0];
        if (subEl) subEl.textContent = p.subtitle;
        /* size panel chips -> our variants */
        var panel = $$('div', el).filter(function (d) {
          var c = (d.className || '') + '';
          return /absolute/.test(c) && /bottom-0/.test(c) && /translate-y/.test(c);
        })[0];
        if (panel) {
          var chipHost = $$('div', panel).filter(function (d) { return /grid/.test((d.className || '') + ''); })[0];
          if (chipHost) {
            var chip = $$('button', chipHost)[0];
            if (chip) {
              var cproto = chip.cloneNode(true);
              chipHost.innerHTML = '';
              p.sizes.forEach(function (s, ix) {
                var b = cproto.cloneNode(true);
                var spans = $$('span', b);
                if (spans[0]) spans[0].textContent = s.label;
                if (spans[1]) spans[1].textContent = money(s.price);
                b.setAttribute('data-sku', s.sku);
                b.setAttribute('data-price', s.price);
                if (s.variant_id) b.setAttribute('data-variant-id', s.variant_id);
                markSelected(b, ix === 0, 'card');
                chipHost.appendChild(b);
              });
            }
          }
          var confirm = $$('button', panel).filter(function (b) { return /^add to cart/i.test(text(b)); })[0];
          if (confirm) confirm.textContent = 'Add to cart — ' + money(p.sizes[0].price);
        }
        el.setAttribute('data-cat', p.category || '');
        el.setAttribute('data-name', p.name);
        return el;
      }

      var filtered = cat.slice();
      var page = 1;
      function draw() {
        grid.innerHTML = '';
        var start = (page - 1) * PAGE_SIZE;
        filtered.slice(start, start + PAGE_SIZE).forEach(function (p) { grid.appendChild(card(p)); });
        renderPager();
      }
      function renderPager() {
        var nav = $('nav[aria-label="Product pagination"]');
        if (!nav) return;
        var pages = Math.max(1, Math.ceil(filtered.length / PAGE_SIZE));
        var btns = $$('button', nav);
        var prev = btns[0], next = btns[btns.length - 1];
        var numProto = btns[1] ? btns[1].cloneNode(true) : null;
        btns.slice(1, -1).forEach(function (b) { b.remove(); });
        if (numProto) {
          for (var i = 1; i <= pages; i++) {
            var b = numProto.cloneNode(true);
            b.textContent = i;
            b.className = 'inline-flex h-10 w-10 items-center justify-center rounded-full border text-sm font-semibold transition-colors ' +
              (i === page ? 'border-transparent bg-[#27599f] text-white shadow-sm'
                          : 'border-slate-300 text-slate-700 hover:border-slate-500 hover:bg-slate-50');
            if (i === page) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current');
            (function (n) { b.onclick = function () { page = n; draw(); window.scrollTo({ top: 0, behavior: 'smooth' }); }; })(i);
            nav.insertBefore(b, next);
          }
        }
        if (prev) { prev.disabled = page <= 1; prev.onclick = function () { if (page > 1) { page--; draw(); window.scrollTo({ top: 0, behavior: 'smooth' }); } }; }
        if (next) { next.disabled = page >= pages; next.onclick = function () { if (page < pages) { page++; draw(); window.scrollTo({ top: 0, behavior: 'smooth' }); } }; }
      }
      window.FORMERA_GRID = {
        filter: function (re) {
          filtered = re ? cat.filter(function (p) { return re.test(p.category + ' ' + p.subtitle + ' ' + p.name); }) : cat.slice();
          page = 1; draw();
        },
        search: function (q) {
          filtered = q ? cat.filter(function (p) { return (p.name + ' ' + p.subtitle).toLowerCase().indexOf(q.toLowerCase()) > -1; }) : cat.slice();
          page = 1; draw();
        },
        sort: function (v) {
          if (/low|asc/i.test(v)) filtered.sort(function (a, b) { return a.price - b.price; });
          else if (/high|desc/i.test(v)) filtered.sort(function (a, b) { return b.price - a.price; });
          page = 1; draw();
        }
      };
      draw();
      /* ALSO re-render every SECONDARY card grid (search-overlay "Relevant Products", PDP
         "Frequently bought together", homepage rails). Otherwise those keep the captured
         reference site's product names/prices and add stale items with no Shopify variant_id. */
      try {
        var secondary = $$('div[class*="grid"], div[class*="flex"]').filter(function (g) {
          if (g === grid) return false;
          var links = $$('a[href^="product.html"]', g).length;
          return links >= 2 && links <= 8 && !g.contains(grid);
        });
        var used = [];
        secondary.forEach(function (g) {
          var kids = $$(':scope > div', g).filter(function (k) { return $('a[href^="product.html"]', k); });
          if (!kids.length) return;
          kids.forEach(function (k, ix) {
            var p2 = cat[(ix + used.length) % cat.length];
            var fresh = card(p2);
            /* keep the secondary container's own sizing classes on the wrapper */
            fresh.className = k.className;
            k.replaceWith(fresh);
          });
          used.push(kids.length);
        });
      } catch (e) {}
      /* honour ?category= deep links from the footer */
      var qc = new URLSearchParams(location.search).get('category');
      if (qc) window.FORMERA_GRID.filter(new RegExp(qc.replace(/\+/g, ' '), 'i'));
    });
  }

  /* ========================= PDP: render the requested ?sku= =========================
     product.html is a single template (per spec: one product page driven by product data).
     Without this, every "Frequently bought together" link reloads the same product and just
     appears to jump to the top of the page. */
  function initSkuRouting() {
    /* Round 5 — Shopify PDP.  templates/product.liquid renders EVERYTHING from the product object
       and embeds the same data as JSON for this layer.  We only wire behaviour; we never rewrite
       the markup (that was the old ?sku= path, which could not work on /products/<handle>). */
    var node = document.getElementById('formera-product-json');
    if (!node) return;
    var p;
    try { p = JSON.parse(node.textContent); } catch (e) { return; }
    if (!p || !p.sizes || !p.sizes.length) return;

    PDP.product = { name: p.title, img: p.img, sizes: p.sizes, subtitle: p.type };
    var first = p.sizes[0];
    /* respect whatever chip Liquid marked selected */
    var pre = $$('button').filter(function (b) {
      return /^select size/i.test(label(b)) && b.getAttribute('aria-pressed') === 'true';
    })[0];
    if (pre) {
      var pid = pre.getAttribute('data-variant-id');
      first = p.sizes.filter(function (z) { return String(z.variant_id) === String(pid); })[0] || first;
    }
    PDP.variant = first.label; PDP.price = first.price;
    PDP.sku = first.sku; PDP.variant_id = first.variant_id;
    /* 📊 META ViewContent — product-page load, browser + CAPI. Fires once per PDP render, after the
       default variant is resolved so the id and value are the real ones the shopper is looking at. */
    try{
      if (window.fmTrackVC && !window.__fmVCFired) {
        window.__fmVCFired = true;
        window.fmTrackVC([{ id: String(first.variant_id || first.sku || ''), quantity: 1 }],
                         Number(first.price) || 0);
      }
    }catch(e){}

    var tierBtns = $$('button').filter(function (b) { return /vial/i.test(text(b)); });
    tierBtns.forEach(function (b, ix) { markSelected(b, ix === 0, 'tier'); });
    PDP.tier = 1; PDP.qty = 1;
    syncPdpPrice();
  }

  /* Swap the hero vial + the "Size:" line when a dosage chip is picked. Both are rendered by
     Liquid with data-variant-img / data-formera-size, so this is a pure state toggle. */
  function showVariantImage(vid, btn) {
    /* Single hero <img> — swap its src.  (The reference's opacity-crossfade stack was verified to
       stall at opacity 0 and, when lazy, never to load at all.  See _FORMERA-SYSTEM-MAP §12.) */
    var hero = document.querySelector('img[data-formera-hero]');
    if (!hero) return;
    var url = btn && btn.getAttribute ? btn.getAttribute('data-img') : null;
    if (!url && PDP.product && PDP.product.sizes) {
      var s2 = PDP.product.sizes.filter(function (z) { return String(z.variant_id) === String(vid); })[0];
      url = s2 && s2.img;
    }
    if (!url) return;
    hero.setAttribute('src', url);
    var spacer = hero.previousElementSibling;
    if (spacer && spacer.tagName === 'IMG') spacer.setAttribute('src', url);
  }

  /* ── SLIDE-CART DISCOUNT CODES (added 2026-08-05, Dom: "the coupon code section in the SLIDE
     CART is not functional").  The input and Apply button shipped as pure markup with NO handler —
     nothing was bound, so clicking Apply did literally nothing.
     Validation is delegated to the SAME worker route the checkout uses (`/api/discount` on
     checkout.formeralabs.com), so there is exactly one pricing authority and the cart can never
     disagree with the charge.  The accepted code is persisted to localStorage('formera_discount')
     and the checkout page re-validates it SERVER-SIDE at intent time, so a tampered localStorage
     value cannot move the price. */
  var FORMERA_CHECKOUT_ORIGIN = 'https://checkout.formeralabs.com';
  /* 🔴 THE STALE-DISCOUNT BUG (Dom, 2026-08-05): the stored object held a frozen `amountOff`
     computed against the cart it was applied to. Swap the cart contents and that number survived —
     a $190 discount from 3× GLP-3 R 50mg was still showing on a $295 cart of three different
     vials, so the slide cart said $105 while checkout (which re-validates on load) said $255.
     A price the customer sees must never come from a stale calculation.
     Fix: stamp the cart FINGERPRINT onto the stored discount. `cartDiscount()` only returns it if
     the fingerprint still matches the cart as it is right now; otherwise the cart re-prices it
     against the server before anything is displayed. */
  function cartSig(items){
    try{
      return (items||[]).map(function(i){
        return [i.sku||'', i.variant||'', Number(i.price)||0, Number(i.qty)||0].join(':');
      }).sort().join('|');
    }catch(e){ return ''; }
  }
  function storedDiscount(){
    try{ return JSON.parse(localStorage.getItem('formera_discount')||'null') || null; }catch(e){ return null; }
  }
  /* Only a discount priced against THIS exact cart is allowed to render. */
  function cartDiscount(items){
    var d=storedDiscount();
    if(!d || !d.code || !(Number(d.amountOff)>0)) return null;
    if(items && d.sig !== cartSig(items)) return null;   /* stale -> withheld until re-priced */
    return d;
  }
  function setCartDiscount(d){
    try{ if(d) localStorage.setItem('formera_discount', JSON.stringify(d));
         else localStorage.removeItem('formera_discount'); }catch(e){}
  }

  /* Re-price a stored code against the CURRENT cart. Called from render() whenever the cart
     fingerprint no longer matches what the stored discount was priced against — i.e. the moment
     the shopper adds, removes or re-quantities anything. Guarded so a render triggered by the
     re-price cannot loop. */
  var _revalidating = null;
  function revalidateDiscount(items, onDone){
    var d=storedDiscount();
    if(!d || !d.code) return;
    var sig=cartSig(items);
    if(d.sig===sig) return;                 /* already priced against this cart */
    if(_revalidating===sig) return;         /* in flight for this exact cart */
    _revalidating=sig;
    if(!items.length){ setCartDiscount(null); _revalidating=null; if(onDone) onDone(); return; }
    fetch(FORMERA_CHECKOUT_ORIGIN+'/api/discount',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ code:d.code, items: items.map(function(i){
        return {sku:i.sku,name:i.name,variant:i.variant,price:i.price,qty:i.qty,variant_id:i.variant_id};})})
    }).then(function(r){return r.json();}).then(function(res){
      _revalidating=null;
      if(res && res.ok && Number(res.amountOff)>0){
        setCartDiscount({code:res.code, amountOff:res.amountOff, label:res.label||res.code,
                         kind:res.kind||'', freeUnits:res.freeUnits||[], sig:sig});
      } else {
        setCartDiscount(null);              /* no longer qualifies on this cart */
      }
      if(onDone) onDone(res);
    }).catch(function(){ _revalidating=null; setCartDiscount(null); if(onDone) onDone(null); });
  }

  /* discount ladder read from the tier buttons themselves ("3% off", "5% off", "8% off") */
  function tierPctFor(n) {
    var found = 0;
    $$('button').forEach(function (b) {
      var t = text(b);
      if (!/\bvial/i.test(t)) return;
      var q = t.match(/(\d+)\s*\+?\s*vial/i), d = t.match(/(\d+)\s*%/);
      if (q && d && parseInt(q[1], 10) === n) found = parseInt(d[1], 10);
    });
    return found;
  }

  /* ---- QUANTITY stepper (their markup: a span for mobile + an input for lg) ---- */
  function qtyEls() {
    var inp = $('input[aria-label="Quantity"]');
    if (!inp) return null;
    var wrap = inp.parentElement;
    var span = $$('span', wrap).filter(function (s) { return /^\d+$/.test(text(s)); })[0];
    return { inp: inp, span: span, wrap: wrap };
  }
  function setQty(n) {
    var q = qtyEls(); if (!q) return;
    n = Math.max(1, Math.min(99, n));
    PDP.qty = n;
    q.inp.value = n;
    if (q.span) q.span.textContent = n;
    syncPdpPrice();
  }


  /* ========================= AGE / RESEARCHER GATE =========================
     REMOVED 2026-07-28. The gate is no longer drawn here.  This file is `defer`red, so anything it
     painted necessarily appeared AFTER the dirty page had already rendered — a visible leak.
     The gate now lives in `snippets/age-gate.liquid`, inline and synchronous at the very top of
     <head>, and redirects to /pages/age-verify (the LUM model).  See _FORMERA-SYSTEM-MAP §7.
     `window.FORMERA_GATE` (defined by that snippet) is the only gate API now. */
  function gateValid() { return !window.FORMERA_GATE || window.FORMERA_GATE.ok(); }

  /* ========================= CHECKOUT HANDOFF =========================
     Ported from the Euphoria/LUM checkout guard (see _EUPHORIA-SYSTEM-MAP + the cross-brand
     CHECKOUT-FEATURE-MATRIX).  Two jobs:
       1. every checkout path goes to OUR custom checkout, never Shopify's native one;
       2. the cart travels ON THE LINK.  checkout.formeralabs.com is a DIFFERENT ORIGIN, so it can
          never read localStorage['formera_cart'] written on formeralabs.com — without this the
          shopper lands on an empty checkout.
     Add-to-cart is deliberately NOT touched: it opens the slide cart, as it does today. */
  var CHECKOUT_ORIGIN = 'https://checkout.formeralabs.com';
  function cartToken() {
    try {
      /* `promo` rides INSIDE the cart token rather than as a separate ?discount= param.
         Two reasons: localStorage is per-origin so the code cannot cross any other way, and a
         plain craftable ?discount= is exactly what rule §10.2 removed on 2026-07-19. Only the
         CODE travels — never the amount; the worker re-prices it. */
      var _d = cartDiscount();
      var payload = { v: 1, ts: Date.now(), items: Cart.items(), promo: _d ? _d.code : '' };
      var json = JSON.stringify(payload);
      var b64 = btoa(unescape(encodeURIComponent(json)));
      return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    } catch (e) { return ''; }
  }
  function checkoutUrl() {
    var t = cartToken();
    /* 📊 append the Meta click id so the WORKER has `fbc` even when the cookie was never written
       (blocker/ITP) — the checkout is a different host, so this is the third of Take LUM's three
       independent paths to fbc. Purely additive to the query string. */
    var fb = (window.fmFbclidQS ? window.fmFbclidQS() : '');
    return CHECKOUT_ORIGIN + '/' + (t ? ('?cart=' + t + fb) : (fb ? ('?' + fb.slice(1)) : ''));
  }
  function goCheckout(e) {
    if (e) { e.preventDefault(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    if (!Cart.items().length) { Cart.open(); return; }   // never ship an empty checkout
    window.location.href = checkoutUrl();
  }
  function initCheckoutGuard() {
    /* accelerated wallets bypass JS and go straight to Shopify native checkout */
    var st = document.createElement('style');
    st.textContent = '.shopify-payment-button,.accelerated-checkout-block,' +
                     '.additional-checkout-buttons,[data-shopify="dynamic-checkout-cart"]' +
                     '{display:none !important;}';
    (document.head || document.documentElement).appendChild(st);
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest(
        'a[href="checkout.html"],a[href$="/checkout"],a[href*="/checkouts/"],' +
        '#checkout,button[name="checkout"],.cart__checkout-button,[data-formera-checkout]');
      if (t) { goCheckout(e); return; }
      /* the slide cart's own CTA, matched by text so a re-render can never orphan it */
      var b = e.target && e.target.closest && e.target.closest('a,button');
      if (b && /^proceed to checkout/i.test((b.textContent || '').trim())) goCheckout(e);
    }, true);
    document.addEventListener('submit', function (e) {
      var f = e.target, a = (f && f.getAttribute && (f.getAttribute('action') || '')) || '';
      if (/\/checkout(\/|\?|$)/.test(a)) goCheckout(e);
    }, true);
  }
  window.FORMERA_CHECKOUT = { url: checkoutUrl, go: goCheckout };

  /* ========================= BOOT ========================= */
  function boot() {
    try { initSkuRouting(); } catch (e) {}
    try { initCatalogGrid(); } catch (e) {}
    try { initCheckoutGuard(); } catch (e) {}
    try { initParticles(); } catch (e) {}
    try { Cart.init(); }     catch (e) {}
    try { Search.init(); }   catch (e) {}
    try { initProducts(); }  catch (e) {}
    try { initGallery(); }   catch (e) {}
    try { initCoaArchive(); initPdpCoa(); }    catch (e) {}
    /* authoritative last word on a product page — nothing may leave PDP.price pointing at
       another product's number (see the note in initGallery). */
    try { initSkuRouting(); } catch (e) {}
    document.addEventListener('click', function (e) { try { route(e); } catch (err) {} }, false);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var lbx = $('#formera-coa-lightbox'); if (lbx) { lbx.remove(); lock(false); }
      Cart.close(); Search.close();
      slideShut(asideBy('Menu')); anyScrimOff(); lock(false);
    });
    scrims().forEach(function (s) {
      s.addEventListener('click', function () {
        Cart.close(); slideShut(asideBy('Menu')); Search.close(); anyScrimOff(); lock(false);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.FORMERA = { cart: Cart, pdp: PDP, gate: { valid: gateValid, reset: function(){ try{localStorage.removeItem(LS_GATE);}catch(e){} } } };
})();
